import {connect} from 'react-redux';
import Hit from './Hit';
import {getHitTranslations} from '../../selectors';

function mapStateToProps(state) {
    return {
        translations: getHitTranslations(state)
    };
}

export default connect(mapStateToProps)(Hit);



// WEBPACK FOOTER //
// ./src/universal/components/Hit/hit-container.js